import {App, plugin} from '@inertiajs/inertia-vue';

import {InertiaProgress} from '@inertiajs/progress';

import Vue from "vue";
import VueMeta from 'vue-meta';
import store from "./store/index";
import vuetify from "./plugins/vuetify";
import {mask} from 'vue-the-mask'
import '@koumoul/vjsf/lib/deps/third-party.js';

import Lang from 'lang.js';
import trans from "./trans";

Vue.prototype.trans = new Lang({
    messages: trans
});

Vue.mixin({methods: {route: window.route}})

Vue.use(VueMeta)
Vue.use(plugin)

Vue.component('VJsf', () => import('./utils/form/BoxJsForm'));
Vue.directive('mask', mask);

InertiaProgress.init();

const el = document.getElementById("app");

window.app = new Vue({
    store,
    vuetify,
    render: h =>
        h(App, {
            props: {
                initialPage: JSON.parse(el.dataset.page),
                resolveComponent: name =>
                    import(`@/Pages/${name}`).then(module => module.default),
                wrapperComponent: () =>
                    import('./Pages/Shared/Layout')
            }
        })
}).$mount(el);
